import { createFileRoute, Link, Outlet, useRouterState, redirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/_authenticated/admin")({
  beforeLoad: async () => {
    const { data: u } = await supabase.auth.getUser();
    if (!u.user) throw redirect({ to: "/auth" });
    const { data } = await supabase.from("user_roles").select("role").eq("user_id", u.user.id).eq("role", "admin").maybeSingle();
    if (!data) throw redirect({ to: "/dashboard" });
  },
  component: AdminLayout,
});

const tabs = [
  { to: "/admin", label: "Overview" },
  { to: "/admin/users", label: "Users" },
  { to: "/admin/deposits", label: "Deposits" },
  { to: "/admin/withdrawals", label: "Withdrawals" },
  { to: "/admin/plans", label: "Plans" },
  { to: "/admin/bots", label: "Bot tiers" },
  { to: "/admin/invite-codes", label: "Invite codes" },
  { to: "/admin/support", label: "Support" },
  { to: "/admin/announcements", label: "Announcements" },
  { to: "/admin/emails", label: "Emails" },
  { to: "/admin/settings", label: "Settings" },
  { to: "/admin/verify", label: "Verify access" },
  { to: "/admin/build-diagnostics", label: "Build diagnostics" },
  { to: "/admin/build-logs", label: "Build logs" },
] as const;

function AdminLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Admin dashboard</h1>
        <p className="text-sm text-muted-foreground">Manage users, deposits, withdrawals, and platform content.</p>
      </div>
      <nav className="flex flex-wrap gap-1 border-b border-white/10">
        {tabs.map((t) => {
          const isActive = t.to === "/admin" ? pathname === "/admin" : pathname.startsWith(t.to);
          return (
            <Link key={t.to} to={t.to} className={`px-4 py-2 text-sm border-b-2 -mb-px transition-colors ${isActive ? "border-primary text-foreground" : "border-transparent text-muted-foreground hover:text-foreground"}`}>
              {t.label}
            </Link>
          );
        })}
      </nav>
      <Outlet />
    </div>
  );
}